// // src/pages/BooksPage.js
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";

// const BooksPage = ({ language }) => {
//   const [books, setBooks] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchParams, setSearchParams] = useSearchParams();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);

//         // Fetch categories
//         const categoriesResponse = await axios.get(
//           process.env.REACT_APP_BASE_URL +
//             "library-category/get-all-library-category"
//         );
//         setCategories(categoriesResponse.data.data);

//         // Fetch books
//         const booksResponse = await axios.get(
//           process.env.REACT_APP_BASE_URL + "book/get-all-books"
//         );
//         setBooks(booksResponse.data.data);

//         // Check if category ID is in URL params
//         const categoryId = searchParams.get("category");
//         if (categoryId) {
//           const category = categoriesResponse.data.data.find(
//             (cat) => cat.id.toString() === categoryId
//           );
//           if (category) {
//             setSelectedCategory(category);
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [searchParams]);

//   // Filter books based on selected category and search query
//   const filteredBooks = books.filter((book) => {
//     const matchesCategory =
//       !selectedCategory || book.category_id === selectedCategory.id;
//     const matchesSearch =
//       !searchQuery ||
//       book.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       book.title_ar.includes(searchQuery);

//     return matchesCategory && matchesSearch;
//   });

//   const handleCategorySelect = (category) => {
//     setSelectedCategory(category);
//     setSearchParams({ category: category.id });
//   };

//   const handleClearFilters = () => {
//     setSelectedCategory(null);
//     setSearchQuery("");
//     setSearchParams({});
//   };

//   const handleBack = () => {
//     navigate(-1);
//   };

//   const handleBookClick = (book) => {
//     // Navigate to book details page or open book viewer
//     console.log("Book clicked:", book);
//     // You can implement book details page or PDF viewer here
//   };

//   const getCategoryName = (categoryId) => {
//     const category = categories.find((cat) => cat.id === categoryId);
//     return category
//       ? language === "ar"
//         ? category.title_ar
//         : category.title
//       : "Unknown Category";
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 py-12">
//         <div className="container mx-auto px-4">
//           <div className="text-center">
//             <div className="animate-pulse">
//               <div className="h-8 bg-green-200 rounded w-48 mx-auto mb-4"></div>
//               <div className="h-1 bg-green-200 rounded w-24 mx-auto mb-4"></div>
//               <div className="h-4 bg-green-200 rounded w-64 mx-auto"></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 py-12">
//       <div
//         className="container mx-auto px-4"
//         style={{
//           marginTop: "10rem",
//         }}
//       >
//         {/* Header */}
//         <div className="text-center mb-12">
//           <button
//             onClick={handleBack}
//             className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg mb-6"
//           >
//             {language === "ar" ? "العودة" : "Back"}
//           </button>

//           <h1 className="text-4xl md:text-5xl font-bold text-green-900 mb-4">
//             {language === "ar" ? "المكتبة الرقمية" : "Digital Library"}
//           </h1>
//           <div className="w-32 h-1 bg-green-600 mx-auto"></div>
//           <p className="text-gray-600 max-w-2xl mx-auto mt-4">
//             {language === "ar"
//               ? "استكشف مجموعة الكتب والمراجع التدريبية المتاحة في مكتبتنا الرقمية"
//               : "Explore the collection of books and training references available in our digital library"}
//           </p>
//         </div>

//         {/* Search and Filter Section */}
//         <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
//           <div className="grid md:grid-cols-2 gap-6">
//             {/* Search Input */}
//             <div className="relative">
//               <input
//                 type="text"
//                 placeholder={
//                   language === "ar" ? "ابحث في الكتب..." : "Search books..."
//                 }
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 className="w-full px-6 py-4 border border-green-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
//               />
//               <button className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-green-600 text-white p-2 rounded-lg hover:bg-green-700 transition-colors">
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                   />
//                 </svg>
//               </button>
//             </div>

//             {/* Category Filter */}
//             <div className="relative">
//               <select
//                 value={selectedCategory?.id || ""}
//                 onChange={(e) => {
//                   const categoryId = e.target.value;
//                   if (categoryId) {
//                     const category = categories.find(
//                       (cat) => cat.id.toString() === categoryId
//                     );
//                     handleCategorySelect(category);
//                   } else {
//                     handleClearFilters();
//                   }
//                 }}
//                 className="w-full px-6 py-4 border border-green-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent appearance-none bg-white"
//               >
//                 <option value="">
//                   {language === "ar" ? "جميع الفئات" : "All Categories"}
//                 </option>
//                 {categories.map((category) => (
//                   <option key={category.id} value={category.id}>
//                     {language === "ar" ? category.title_ar : category.title}
//                   </option>
//                 ))}
//               </select>
//               <div className="absolute right-6 top-1/2 transform -translate-y-1/2 pointer-events-none">
//                 <svg
//                   className="w-4 h-4 text-green-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M19 9l-7 7-7-7"
//                   />
//                 </svg>
//               </div>
//             </div>
//           </div>

//           {/* Active Filters */}
//           {(selectedCategory || searchQuery) && (
//             <div className="mt-4 flex flex-wrap gap-2 items-center">
//               <span className="text-green-700 font-semibold">
//                 {language === "ar" ? "التصفية:" : "Filters:"}
//               </span>
//               {selectedCategory && (
//                 <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm flex items-center">
//                   {language === "ar"
//                     ? selectedCategory.title_ar
//                     : selectedCategory.title}
//                   <button
//                     onClick={() => setSelectedCategory(null)}
//                     className="ml-2 text-green-600 hover:text-green-800"
//                   >
//                     ×
//                   </button>
//                 </span>
//               )}
//               {searchQuery && (
//                 <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm flex items-center">
//                   {language === "ar" ? "بحث:" : "Search:"} "{searchQuery}"
//                   <button
//                     onClick={() => setSearchQuery("")}
//                     className="ml-2 text-green-600 hover:text-green-800"
//                   >
//                     ×
//                   </button>
//                 </span>
//               )}
//               <button
//                 onClick={handleClearFilters}
//                 className="text-green-600 hover:text-green-800 text-sm font-semibold"
//               >
//                 {language === "ar" ? "مسح الكل" : "Clear all"}
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Results Count */}
//         <div className="mb-6">
//           <p className="text-green-700">
//             {language === "ar"
//               ? `عرض ${filteredBooks.length} من ${books.length} كتاب`
//               : `Showing ${filteredBooks.length} of ${books.length} books`}
//             {selectedCategory && (
//               <span>
//                 {" "}
//                 {language === "ar" ? "في" : "in"} "
//                 {language === "ar"
//                   ? selectedCategory.title_ar
//                   : selectedCategory.title}
//                 "
//               </span>
//             )}
//           </p>
//         </div>

//         {/* Books Grid */}
//         {filteredBooks.length === 0 ? (
//           <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
//             <div className="text-6xl mb-4">📚</div>
//             <h3 className="text-2xl font-bold text-green-900 mb-4">
//               {language === "ar" ? "لا توجد كتب" : "No Books Found"}
//             </h3>
//             <p className="text-gray-600 mb-6">
//               {language === "ar"
//                 ? "لم نتمكن من العثور على كتب تطابق معايير البحث الخاصة بك."
//                 : "We couldn't find any books matching your search criteria."}
//             </p>
//             <button
//               onClick={handleClearFilters}
//               className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors"
//             >
//               {language === "ar" ? "عرض جميع الكتب" : "View All Books"}
//             </button>
//           </div>
//         ) : (
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//             {filteredBooks.map((book) => (
//               <div
//                 key={book.id}
//                 className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer group"
//                 onClick={() => handleBookClick(book)}
//               >
//                 {/* Book Image */}
//                 <div className="h-48 bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center relative overflow-hidden">
//                   {book.image ? (
//                     <img
//                       src={process.env.REACT_APP_BASE_URL + book.image}
//                       alt={language === "ar" ? book.title_ar : book.title}
//                       className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
//                     />
//                   ) : (
//                     <div className="text-center text-green-600">
//                       <div className="text-6xl mb-2">📖</div>
//                       <p className="text-sm font-semibold">
//                         {language === "ar" ? "لا توجد صورة" : "No Image"}
//                       </p>
//                     </div>
//                   )}
//                   <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300"></div>
//                 </div>

//                 {/* Book Info */}
//                 <div className="p-6">
//                   <h3 className="font-bold text-lg text-green-900 mb-2 line-clamp-2 group-hover:text-green-700 transition-colors">
//                     {language === "ar" ? book.title_ar : book.title}
//                   </h3>

//                   <p className="text-green-600 text-sm mb-3">
//                     {getCategoryName(book.category_id)}
//                   </p>

//                   <div className="flex justify-between items-center text-sm text-gray-500">
//                     <span>
//                       {language === "ar" ? "تم الإضافة:" : "Added:"}{" "}
//                       {new Date(book.createdAt).toLocaleDateString("en-US")}
//                     </span>
//                   </div>

//                   {/* <button className="w-full mt-4 bg-green-600 text-white py-2 rounded-lg font-semibold hover:bg-green-700 transition-colors group-hover:bg-green-700">
//                     {language === "ar" ? "عرض الكتاب" : "View Book"} →
//                   </button> */}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Quick Category Navigation */}
//         <div className="mt-12 bg-green-50 rounded-2xl p-8">
//           <h3 className="text-2xl font-bold text-green-900 mb-6 text-center">
//             {language === "ar" ? "تصفح حسب الفئة" : "Browse by Category"}
//           </h3>
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
//             {categories.map((category) => (
//               <button
//                 key={category.id}
//                 onClick={() => handleCategorySelect(category)}
//                 className={`p-4 rounded-lg text-center transition-all ${
//                   selectedCategory?.id === category.id
//                     ? "bg-green-600 text-white shadow-lg"
//                     : "bg-white text-green-800 hover:bg-green-100 shadow-md"
//                 }`}
//               >
//                 <div className="text-2xl mb-2">{category.icon || "📚"}</div>
//                 <div className="text-sm font-semibold leading-tight">
//                   {language === "ar" ? category.title_ar : category.title}
//                 </div>
//                 <div className="text-xs opacity-75 mt-1">
//                   {category.bookCount} {language === "ar" ? "كتاب" : "books"}
//                 </div>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BooksPage;


// src/pages/BooksPage.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const BooksPage = ({ language }) => {
  const [books, setBooks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // New state for image modal
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch categories
        const categoriesResponse = await axios.get(
          process.env.REACT_APP_BASE_URL +
            "library-category/get-all-library-category"
        );
        setCategories(categoriesResponse.data.data);

        // Fetch books
        const booksResponse = await axios.get(
          process.env.REACT_APP_BASE_URL + "book/get-all-books"
        );
        setBooks(booksResponse.data.data);

        // Check if category ID is in URL params
        const categoryId = searchParams.get("category");
        if (categoryId) {
          const category = categoriesResponse.data.data.find(
            (cat) => cat.id.toString() === categoryId
          );
          if (category) {
            setSelectedCategory(category);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [searchParams]);

  // Filter books based on selected category and search query
  const filteredBooks = books.filter((book) => {
    const matchesCategory =
      !selectedCategory || book.category_id === selectedCategory.id;
    const matchesSearch =
      !searchQuery ||
      book.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      book.title_ar.includes(searchQuery);

    return matchesCategory && matchesSearch;
  });

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setSearchParams({ category: category.id });
  };

  const handleClearFilters = () => {
    setSelectedCategory(null);
    setSearchQuery("");
    setSearchParams({});
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleBookClick = (book) => {
    // Navigate to book details page or open book viewer
    console.log("Book clicked:", book);
    // You can implement book details page or PDF viewer here
  };

  // New function to handle image click
  const handleImageClick = (e, book) => {
    e.stopPropagation(); // Prevent triggering the book click
    if (book.image) {
      setSelectedImage(process.env.REACT_APP_BASE_URL + book.image);
      setIsModalOpen(true);
    }
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  // Handle keyboard events (ESC to close)
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    
    if (isModalOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
    }
    
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  const getCategoryName = (categoryId) => {
    const category = categories.find((cat) => cat.id === categoryId);
    return category
      ? language === "ar"
        ? category.title_ar
        : category.title
      : "Unknown Category";
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="animate-pulse">
              <div className="h-8 bg-green-200 rounded w-48 mx-auto mb-4"></div>
              <div className="h-1 bg-green-200 rounded w-24 mx-auto mb-4"></div>
              <div className="h-4 bg-green-200 rounded w-64 mx-auto"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="min-h-screen bg-gray-50 py-12">
        <div
          className="container mx-auto px-4"
          style={{
            marginTop: "10rem",
          }}
        >
          {/* Header */}
          <div className="text-center mb-12">
            <button
              onClick={handleBack}
              className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg mb-6"
            >
              {language === "ar" ? "العودة" : "Back"}
            </button>

            <h1 className="text-4xl md:text-5xl font-bold text-green-900 mb-4">
              {language === "ar" ? "المكتبة الرقمية" : "Digital Library"}
            </h1>
            <div className="w-32 h-1 bg-green-600 mx-auto"></div>
            <p className="text-gray-600 max-w-2xl mx-auto mt-4">
              {language === "ar"
                ? "استكشف مجموعة الكتب والمراجع التدريبية المتاحة في مكتبتنا الرقمية"
                : "Explore the collection of books and training references available in our digital library"}
            </p>
          </div>

          {/* Search and Filter Section */}
          <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
            <div className="grid md:grid-cols-2 gap-6">
              {/* Search Input */}
              <div className="relative">
                <input
                  type="text"
                  placeholder={
                    language === "ar" ? "ابحث في الكتب..." : "Search books..."
                  }
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-6 py-4 border border-green-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
                <button className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-green-600 text-white p-2 rounded-lg hover:bg-green-700 transition-colors">
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </div>

              {/* Category Filter */}
              <div className="relative">
                <select
                  value={selectedCategory?.id || ""}
                  onChange={(e) => {
                    const categoryId = e.target.value;
                    if (categoryId) {
                      const category = categories.find(
                        (cat) => cat.id.toString() === categoryId
                      );
                      handleCategorySelect(category);
                    } else {
                      handleClearFilters();
                    }
                  }}
                  className="w-full px-6 py-4 border border-green-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent appearance-none bg-white"
                >
                  <option value="">
                    {language === "ar" ? "جميع الفئات" : "All Categories"}
                  </option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {language === "ar" ? category.title_ar : category.title}
                    </option>
                  ))}
                </select>
                <div className="absolute right-6 top-1/2 transform -translate-y-1/2 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Active Filters */}
            {(selectedCategory || searchQuery) && (
              <div className="mt-4 flex flex-wrap gap-2 items-center">
                <span className="text-green-700 font-semibold">
                  {language === "ar" ? "التصفية:" : "Filters:"}
                </span>
                {selectedCategory && (
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm flex items-center">
                    {language === "ar"
                      ? selectedCategory.title_ar
                      : selectedCategory.title}
                    <button
                      onClick={() => setSelectedCategory(null)}
                      className="ml-2 text-green-600 hover:text-green-800"
                    >
                      ×
                    </button>
                  </span>
                )}
                {searchQuery && (
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm flex items-center">
                    {language === "ar" ? "بحث:" : "Search:"} "{searchQuery}"
                    <button
                      onClick={() => setSearchQuery("")}
                      className="ml-2 text-green-600 hover:text-green-800"
                    >
                      ×
                    </button>
                  </span>
                )}
                <button
                  onClick={handleClearFilters}
                  className="text-green-600 hover:text-green-800 text-sm font-semibold"
                >
                  {language === "ar" ? "مسح الكل" : "Clear all"}
                </button>
              </div>
            )}
          </div>

          {/* Results Count */}
          <div className="mb-6">
            <p className="text-green-700">
              {language === "ar"
                ? `عرض ${filteredBooks.length} من ${books.length} كتاب`
                : `Showing ${filteredBooks.length} of ${books.length} books`}
              {selectedCategory && (
                <span>
                  {" "}
                  {language === "ar" ? "في" : "in"} "
                  {language === "ar"
                    ? selectedCategory.title_ar
                    : selectedCategory.title}
                  "
                </span>
              )}
            </p>
          </div>

          {/* Books Grid */}
          {filteredBooks.length === 0 ? (
            <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
              <div className="text-6xl mb-4">📚</div>
              <h3 className="text-2xl font-bold text-green-900 mb-4">
                {language === "ar" ? "لا توجد كتب" : "No Books Found"}
              </h3>
              <p className="text-gray-600 mb-6">
                {language === "ar"
                  ? "لم نتمكن من العثور على كتب تطابق معايير البحث الخاصة بك."
                  : "We couldn't find any books matching your search criteria."}
              </p>
              <button
                onClick={handleClearFilters}
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors"
              >
                {language === "ar" ? "عرض جميع الكتب" : "View All Books"}
              </button>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filteredBooks.map((book) => (
                <div
                  key={book.id}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer group"
                  onClick={() => handleBookClick(book)}
                >
                  {/* Book Image with click handler */}
                  <div 
                    className="h-48 bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center relative overflow-hidden"
                    onClick={(e) => handleImageClick(e, book)}
                  >
                    {book.image ? (
                      <>
                        <img
                          src={process.env.REACT_APP_BASE_URL + book.image}
                          alt={language === "ar" ? book.title_ar : book.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 cursor-zoom-in"
                        />
                        {/* Zoom icon overlay */}
                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                          <div className="bg-white p-3 rounded-full shadow-lg">
                            <svg 
                              className="w-6 h-6 text-green-600" 
                              fill="none" 
                              stroke="currentColor" 
                              viewBox="0 0 24 24"
                            >
                              <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth={2} 
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" 
                              />
                            </svg>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="text-center text-green-600">
                        <div className="text-6xl mb-2">📖</div>
                        <p className="text-sm font-semibold">
                          {language === "ar" ? "لا توجد صورة" : "No Image"}
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Book Info */}
                  <div className="p-6">
                    <h3 className="font-bold text-lg text-green-900 mb-2 line-clamp-2 group-hover:text-green-700 transition-colors">
                      {language === "ar" ? book.title_ar : book.title}
                    </h3>

                    <p className="text-green-600 text-sm mb-3">
                      {getCategoryName(book.category_id)}
                    </p>

                    <div className="flex justify-between items-center text-sm text-gray-500">
                      <span>
                        {language === "ar" ? "تم الإضافة:" : "Added:"}{" "}
                        {new Date(book.createdAt).toLocaleDateString("en-US")}
                      </span>
                    </div>

                    {/* <button className="w-full mt-4 bg-green-600 text-white py-2 rounded-lg font-semibold hover:bg-green-700 transition-colors group-hover:bg-green-700">
                      {language === "ar" ? "عرض الكتاب" : "View Book"} →
                    </button> */}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Quick Category Navigation */}
          <div className="mt-12 bg-green-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-green-900 mb-6 text-center">
              {language === "ar" ? "تصفح حسب الفئة" : "Browse by Category"}
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => handleCategorySelect(category)}
                  className={`p-4 rounded-lg text-center transition-all ${
                    selectedCategory?.id === category.id
                      ? "bg-green-600 text-white shadow-lg"
                      : "bg-white text-green-800 hover:bg-green-100 shadow-md"
                  }`}
                >
                  <div className="text-2xl mb-2">{category.icon || "📚"}</div>
                  <div className="text-sm font-semibold leading-tight">
                    {language === "ar" ? category.title_ar : category.title}
                  </div>
                  <div className="text-xs opacity-75 mt-1">
                    {category.bookCount} {language === "ar" ? "كتاب" : "books"}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {isModalOpen && selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-75">
          <div className="relative max-w-7xl max-h-[90vh] w-full h-full">
            {/* Close button */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors"
            >
              <svg 
                className="w-6 h-6 text-gray-700" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
            </button>

            {/* Download button */}
            {/* <button
              onClick={() => window.open(selectedImage, '_blank')}
              className="absolute top-4 left-4 z-10 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors"
              title={language === "ar" ? "تحميل الصورة" : "Download Image"}
            >
              <svg 
                className="w-6 h-6 text-gray-700" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" 
                />
              </svg>
            </button> */}

            {/* Image */}
            <div className="w-full h-full flex items-center justify-center">
              <img
                src={selectedImage}
                alt="Full size book cover"
                className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
              />
            </div>

            {/* Click outside to close */}
            <div 
              className="absolute inset-0 -z-10" 
              onClick={closeModal}
            ></div>
          </div>
        </div>
      )}
    </>
  );
};

export default BooksPage;